<template>
    <div class="animated fadeIn">
        <b-card :class="['global-settings', editId ? 'gray-out' : '']">
            <div class="bookmark-content">
                <div class="bookmarks">
                    <a :class="['bookmark', activeBookmark == 0 ? 'active' : '']" @click="clickBookmark(0)">Domestic pricing</a>
                    <a :class="['bookmark', activeBookmark == 1 ? 'active' : '']" @click="clickBookmark(1)">Roaming pricing</a>
                    <a :class="['bookmark', activeBookmark == 2 ? 'active' : '']" @click="clickBookmark(2)">Vodafone & Kore pricing</a>
                </div>
                <div v-if="activeBookmark == 0" class="domestic-pricing">
                    <div class="content">
                        <div class="filter-row">
                            <a :class="['filter', activeFilterDomestic == 0 ? 'active-filter' : '']" @click="clickFilterDomestic(0)">ALL</a>
                            <a :class="['filter', activeFilterDomestic == 1 ? 'active-filter' : '']" @click="clickFilterDomestic(1)">MB</a>
                            <a :class="['filter', activeFilterDomestic == 2 ? 'active-filter' : '']" @click="clickFilterDomestic(2)">GB</a>
                        </div>
                        <div class="domestic-pricing-list">
                            <div v-for="item in pricesDomestic" :class="['domestic-pricing-box', item.megabyteAllowance < 1024 ? 'mb-pricing' : 'gb-pricing', activeFilterDomestic == 1 ? 'hide-gb' : '', activeFilterDomestic == 2 ? 'hide-mb' : '', item.pricingId == editId ? 'edition-active' : '']">
                                <div v-if="item.pricingId != editId" class="pricing-data">
                                    <div class="header">
                                        <p v-if="item.megabyteAllowance < 1024">{{item.megabyteAllowance}} MB Data Tier</p>
                                        <p v-else>{{item.megabyteAllowance/1024}} GB Data Tier</p>
                                        <i class="fa fa-pencil" @click="editTier(item)"></i>
                                    </div>
                                    <div class="pricing-row">
                                        <span v-if="item.megabyteAllowance < 1024">{{item.megabyteAllowance}} MB</span>
                                        <span v-else>$ {{item.megabyteAllowance/1024}} GB</span>
                                        <span>$ {{item.basePrice.toFixed(2)}}</span>
                                    </div>
                                    <div class="pricing-row">
                                        <span>Overage price</span>
                                        <span>$ {{item.overageRatePerMb.toFixed(3)}}</span>
                                    </div>
                                    <div class="pricing-row">
                                        <span>SMS</span>
                                        <span>$ {{item.ratePerSms.toFixed(2)}}</span>
                                    </div>
                                    <div class="pricing-row">
                                        <span>Suspension charge</span>
                                        <span>$ {{item.ratePerSuspension.toFixed(2)}}</span>
                                    </div>
                                    <div class="pricing-row">
                                        <span>Static IP charge</span>
                                        <span>$ {{item.ratePerStaticIp.toFixed(2)}}</span>
                                    </div>
                                </div>
                                <div v-else class="edition">
                                    <div class="header">
                                        <p v-if="item.megabyteAllowance < 1024">{{item.megabyteAllowance}} MB Data Tier</p>
                                        <p v-else>{{item.megabyteAllowance/1024}} GB Data Tier</p>
                                        <i class="fa fa-close" @click="closeEdition()"></i>
                                    </div>
                                    <div class="edit-row">
                                        <label for="base-price-domestic" v-if="item.megabyteAllowance < 1024">{{item.megabyteAllowance}} MB</label>
                                        <label for="base-price-domestic" v-else>$ {{item.megabyteAllowance/1024}} GB</label>
                                        <input id="base-price-domestic" type="number" min="0" v-model="editData.basePrice">
                                    </div>
                                    <div class="edit-row">
                                        <label for="overage-domestic">Overage price</label>
                                        <input id="overage-domestic" type="number" min="0" v-model="editData.overageRatePerMb">
                                    </div>
                                    <div class="edit-row">
                                        <label for="sms-domestic">SMS</label>
                                        <input id="sms-domestic" type="number" min="0" v-model="editData.ratePerSms">
                                    </div>
                                    <div class="edit-row">
                                        <label for="suspension-domestic">Suspension charge</label>
                                        <input id="suspension-domestic" type="number" min="0" v-model="editData.ratePerSuspension">
                                    </div>
                                    <div class="edit-row">
                                        <label for="staticIP-domestic">Static IP charge</label>
                                        <input id="staticIP-domestic" type="number" min="0" v-model="editData.ratePerStaticIp">
                                    </div>
                                    <div class="control-bar">
                                        <button class="btn btn-light" @click="closeEdition">Cancel</button>
                                        <button class="btn btn-success" @click="updatePrices()">Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="activeBookmark == 1" class="roaming-pricing">
                    <div class="content">
                        <div class="filter-row">
                            <a :class="['filter', activeFilterRoaming == 0 ? 'active-filter' : '']" @click="clickFilterRoaming(0)">ALL</a>
                            <a :class="['filter', activeFilterRoaming == 1 ? 'active-filter' : '']" @click="clickFilterRoaming(1)">MB</a>
                            <a :class="['filter', activeFilterRoaming == 2 ? 'active-filter' : '']" @click="clickFilterRoaming(2)">GB</a>
                        </div>
                        <div class="roaming-pricing-list">
                            <div v-for="item in pricesRoaming"  :class="['roaming-pricing-box', item.megabyteAllowance < 1024 ? 'mb-pricing' : 'gb-pricing', activeFilterRoaming == 1 ? 'hide-gb' : '', activeFilterRoaming == 2 ? 'hide-mb' : '', item.pricingId == editId ? 'edition-active' : '']">
                                <div v-if="item.pricingId != editId" class="pricing-data">
                                    <div class="header">
                                        <p v-if="item.megabyteAllowance < 1024">{{item.megabyteAllowance}} MB Data Tier</p>
                                        <p v-else>{{item.megabyteAllowance/1024}} GB Data Tier</p>
                                        <i class="fa fa-pencil" @click="editTier(item)"></i>
                                    </div>
                                    <div class="pricing-row">
                                        <span v-if="item.megabyteAllowance < 1024">{{item.megabyteAllowance}} MB</span>
                                        <span v-else>$ {{item.megabyteAllowance/1024}} GB</span>
                                        <span>$ {{item.basePrice.toFixed(2)}}</span>
                                    </div>
                                    <div class="pricing-row">
                                        <span>Overage price</span>
                                        <span>$ {{item.overageRatePerMb.toFixed(3)}}</span>
                                    </div>
                                    <div class="pricing-row">
                                        <span>SMS</span>
                                        <span>$ {{item.ratePerSms.toFixed(2)}}</span>
                                    </div>
                                    <div class="pricing-row">
                                        <span>Suspension charge</span>
                                        <span>$ {{item.ratePerSuspension.toFixed(2)}}</span>
                                    </div>
                                    <div class="pricing-row">
                                        <span>Static IP charge</span>
                                        <span>$ {{item.ratePerStaticIp.toFixed(2)}}</span>
                                    </div>
                                </div>
                                <div v-else class="edition">
                                    <div class="header">
                                        <p v-if="item.megabyteAllowance < 1024">{{item.megabyteAllowance}} MB Data Tier</p>
                                        <p v-else>{{item.megabyteAllowance/1024}} GB Data Tier</p>
                                        <i class="fa fa-close" @click="closeEdition()"></i>
                                    </div>
                                    <div class="edit-row">
                                        <label for="base-price-roaming" v-if="item.megabyteAllowance < 1024">{{item.megabyteAllowance}} MB</label>
                                        <label for="base-price-roaming" v-else>$ {{item.megabyteAllowance/1024}} GB</label>
                                        <input id="base-price-roaming" type="number" min="0" v-model="editData.basePrice">
                                    </div>
                                    <div class="edit-row">
                                        <label for="overage-roaming">Overage price</label>
                                        <input id="overage-roaming" type="number" min="0" v-model="editData.overageRatePerMb">
                                    </div>
                                    <div class="edit-row">
                                        <label for="sms-roaming">SMS</label>
                                        <input id="sms-roaming" type="number" min="0" v-model="editData.ratePerSms">
                                    </div>
                                    <div class="edit-row">
                                        <label for="suspension-roaming">Suspension charge</label>
                                        <input id="suspension-roaming" type="number" min="0" v-model="editData.ratePerSuspension">
                                    </div>
                                    <div class="edit-row">
                                        <label for="staticIP-roaming">Static IP charge</label>
                                        <input id="staticIP-roaming" type="number" min="0" v-model="editData.ratePerStaticIp">
                                    </div>
                                    <div class="control-bar">
                                        <button class="btn btn-light" @click="closeEdition">Cancel</button>
                                        <button class="btn btn-success" @click="updatePrices()">Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="activeBookmark == 2" class="vodafone-pricing">
                    <div class="content">
                        <div class="vodafone-pricing-list">
                            <div v-for="item of pricesVodafone" :class="['vodafone-pricing-box', item.pricingId == editId ? 'edition-active' : '']">
                                <div v-if="item.pricingId != editId" class="pricing-data">
                                    <div class="header">
                                        <p>{{item.poolName}} </p>
                                        <i class="fa fa-pencil" @click="editVodafoneTier(item)"></i>
                                    </div>
                                    <div class="pricing-row">
                                        <span>Base price</span>
                                        <span>$ {{item.basePrice.toFixed(3)}}</span>
                                    </div>
                                    <div class="pricing-row">
                                        <span>Overage price</span>
                                        <span>$ {{item.overageRatePerMb.toFixed(3)}}</span>
                                    </div>
                                    <div class="pricing-row">
                                        <span>SMS</span>
                                        <span>$ {{item.smsPrice.toFixed(2)}}</span>
                                    </div>
                                </div>
                                <div v-else class="edition">
                                    <div class="header">
                                        <p>{{item.poolName}} </p>
                                        <i class="fa fa-close" @click="closeVodafoneEdit()"></i>
                                    </div>
                                    <div class="edit-row">
                                        <label for="vodafoneBasePrice">Base price</label>
                                        <input id="vodafoneBasePrice" type="number" min="0" v-model="editData.basePrice">
                                    </div>
                                    <div class="edit-row">
                                        <label for="vodafoneOverage">Overage price</label>
                                        <input id="vodafoneOverage" type="number" min="0" v-model="editData.overageRatePerMb">
                                    </div>
                                    <div class="edit-row">
                                        <label for="vodafoneOverage">SMS price</label>
                                        <input id="vodafoneOverage" type="number" min="0" v-model="editData.smsPrice">
                                    </div>
                                    <div class="control-bar">
                                        <button class="btn btn-light" @click="closeEdition">Cancel</button>
                                        <button class="btn btn-success" @click="updateVodafonePrices()">Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-card>
        <b-modal size="md" ref="unsavedPrices" id="unsavedPrices" centered hide-footer hide-header>
            <img  src="../../assets/img/unsaved-data.png" alt />

            <h3>Unsaved Data</h3>
            <h4>User edition will not be saved, do you wan to continue?</h4>
            <div class="button-wrapper">
                <b-button variant="danger" @click="$refs['unsavedPrices'].hide()">Cancel</b-button>
                <b-button variant="success" @click="cancelChanges()">Continue</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import globalStore from './../../variables';
    import Axios from 'axios';

    export default {
        name: "GlobalSettings",
        data() {
            return {
                activeBookmark: 0,
                activeFilterDomestic: 0,
                activeFilterRoaming: 0,
                pricesDomestic: [],
                pricesRoaming: [],
                pricesVodafone: [],
                editId: null,
                editData: {
                    basePrice: null,
                    megabyteAllowance: null,
                    overageRatePerMb: null,
                    ratePerSms: null,
                    ratePerStaticIp: null,
                    ratePerSuspension: null
                },
                initialEditData: {}
            }
        },
        methods: {
            clickBookmark(bookmark) {
                this.activeBookmark = bookmark;
            },
            clickFilterDomestic(filterId) {
                this.activeFilterDomestic = filterId;
            },
            clickFilterRoaming(filterId) {
                this.activeFilterRoaming = filterId;
            },
            getGlobalPrices() {
                Axios.get( globalStore.data.restApiUrl + '/billing-pricing/default-plan-prices')
                .then( response => {
                    this.pricesDomestic = [];
                    this.pricesRoaming = [];
                    for (let item of response.data) {
                        if (item.roaming) {
                            this.pricesRoaming.push(item);
                        } else {
                            this.pricesDomestic.push(item);
                        }
                    }
                })
                .catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Unable to load global pricing settings.',
                        text: 'Something went wrong during getting global pricing data. Please contact support.',
                        duration: 3000,
                    });
                    console.log(error);
                })
            },
            getVodafonePricing () {
                Axios.get(globalStore.data.restApiUrl + '/billing-pricing/rate-plan/default-plan-prices')
                    .then(response => {
                        this.pricesVodafone = response.data
                    })
            },
            editTier(tier) {
                this.editId = tier.pricingId;
                this.editData = {
                    basePrice: tier.basePrice,
                    megabyteAllowance: tier.megabyteAllowance,
                    overageRatePerMb: tier.overageRatePerMb,
                    ratePerSms: tier.ratePerSms,
                    ratePerStaticIp: tier.ratePerStaticIp,
                    ratePerSuspension: tier.ratePerSuspension
                }
                this.initialEditData = {
                    basePrice: tier.basePrice,
                    megabyteAllowance: tier.megabyteAllowance,
                    overageRatePerMb: tier.overageRatePerMb,
                    ratePerSms: tier.ratePerSms,
                    ratePerStaticIp: tier.ratePerStaticIp,
                    ratePerSuspension: tier.ratePerSuspension
                }
            },
            editVodafoneTier(tier) {
                this.editId = tier.pricingId
                this.editData = {
                    basePrice: tier.basePrice,
                    overageRatePerMb: tier.overageRatePerMb,
                    smsPrice: tier.smsPrice
                }
                this.initialEditData = {
                    basePrice: tier.basePrice,
                    overageRatePerMb: tier.overageRatePerMb,
                    smsPrice: tier.smsPrice
                }
            },
            closeEdition() {
                if (
                    this.initialEditData.basePrice != this.editData.basePrice ||
                    this.initialEditData.overageRatePerMb != this.editData.overageRatePerMb ||
                    this.initialEditData.ratePerSms != this.editData.ratePerSms ||
                    this.initialEditData.ratePerStaticIp != this.editData.ratePerStaticIp ||
                    this.initialEditData.ratePerSuspension != this.editData.ratePerSuspension
                ) {
                    this.$refs['unsavedPrices'].show();
                } else {
                    this.editId = null;
                    this.editData = {}
                }
            },
            closeVodafoneEdit() {
                if (this.initialEditData.basePrice != this.editData.basePrice || this.initialEditData.overageRatePerMb != this.editData.overageRatePerMb) {
                    this.$refs['unsavedPrices'].show();
                } else {
                    this.editId = null;
                    this.editData = {}
                }
            },
            cancelChanges () {
                this.editId = null;
                this.editData = {};

                this.$refs['unsavedPrices'].hide();
            },
            updatePrices() {
                if (
                    Number(this.editData.basePrice) == 0 ||
                    Number(this.editData.overageRatePerMb) == 0 ||
                    Number(this.editData.ratePerSms) == 0 ||
                    Number(this.editData.ratePerStaticIp) == 0 ||
                    Number(this.editData.ratePerSuspension) == 0
                ) {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Entered price is wrong.',
                        text: 'One of prices you trying to save contains letters or is equal zero, please remove incorrect characters and try again.',
                        duration: 5000,
                    });
                } else {
                    let parsedData = {
                        basePrice: Number(this.editData.basePrice),
                        ratePerOverageMb: Number(this.editData.overageRatePerMb),
                        smsCharge: Number(this.editData.ratePerSms),
                        staticIpCharge: Number(this.editData.ratePerStaticIp),
                        suspensionCharge: Number(this.editData.ratePerSuspension)
                    }
                    Axios.patch( globalStore.data.restApiUrl + '/billing-pricing/default-plan-prices/' + this.editId, parsedData)
                    .then(response => {
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Global pricing updated.',
                            text: 'Your update has been saved in the database.',
                            duration: 3000,
                        });
                        this.getGlobalPrices();
                        this.editId = null;
                        this.editData = {};
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Global pricing update not saved.',
                            text: 'Something went wrong during saving global pricing update. Please contact support.',
                            duration: 3000,
                        });
                        console.log(error)
                    })
                }
            },
            updateVodafonePrices() {
                let parsedData = {
                    basePrice: Math.round(Number(this.editData.basePrice) * 1000) / 1000,
                    ratePerOverageMb: Math.round(Number(this.editData.overageRatePerMb) * 1000) / 1000,
                    smsPrice: Math.round(Number(this.editData.smsPrice) * 100) / 100
                }

                Axios.patch(globalStore.data.restApiUrl + '/billing-pricing/rate-plan/default-plan-prices/' + this.editId, parsedData)
                    .then(response => {
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Global pricing updated.',
                            text: 'Your update has been saved in the database.',
                            duration: 3000,
                        });
                        this.getVodafonePricing()
                        this.editId = null;
                        this.editData = {}
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Global pricing update not saved.',
                            text: 'Something went wrong during saving global pricing update. Please contact support.',
                            duration: 3000,
                        });
                        console.log(error)
                    })
            }
        },
        created() {
            this.getGlobalPrices();
            this.getVodafonePricing()
        }
    }
</script>

<style lang="scss">
    .global-settings {
        &.gray-out {
            position: relative;
            &::before {
                content: '';
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                background-color: rgba(0,0,0,0.5);
                z-index: 10;
            }

        }
        .card-body {
            position: relative;
            display: flex;
            flex-direction: column;
            padding: 0;
            height: calc(100vh - 154px);

            -webkit-margin-end: 3px; // 3px -> caused by custom scroll
            -webkit-margin-before: 3px; // 3px -> caused by custom scroll

            .bookmark-content {
                padding: 20px;
                overflow-y: auto;

                .bookmarks {
                    display: flex;

                    .bookmark {
                        padding: 17px 25px;
                        font-weight: 700;
                        cursor: pointer;

                        &.active {
                            border-top: 1px solid #C9CFD4;
                            border-left: 1px solid #C9CFD4;
                            border-right: 1px solid #C9CFD4;
                            border-bottom: 1px solid #ffffff;
                            margin-bottom: -1px;
                            color: #0088FF;
                            border-top-right-radius: 5px;
                            border-top-left-radius: 5px;
                            z-index: 2;
                        }
                    }
                }

                .roaming-pricing,
                .domestic-pricing,
                .vodafone-pricing {
                    .filter-row {
                        margin-bottom: 24px;
                        .filter {
                            margin-right: 40px;
                            font-size: 15px;
                            font-weight: 700;
                            cursor: pointer;
                            &.active-filter {
                                color: #0088FF;
                            }
                        }
                    }
                }


                .domestic-pricing {
                    position: relative;
                    max-height: none;
                    padding: 20px;
                    border: 1px solid #C9CFD4;
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;
                    border-top-left-radius: 0px;

                    .domestic-pricing-list {
                        display: flex;
                        flex-wrap: wrap;

                        .domestic-pricing-box {
                            max-width: 250px;
                            width: 20%;
                            padding: 3px;
                            margin-right: 20px;
                            margin-bottom: 20px;
                            -webkit-border-radius: 5px;
                            -moz-border-radius: 5px;
                            border-radius: 5px;
                            border: 1px solid #dee1e3;
                            background-color: #fff;

                            &.mb-pricing {
                                &.hide-mb {
                                    display: none;
                                }
                            }

                            &.gb-pricing {
                                &.hide-gb {
                                    display: none;
                                }
                            }

                            &.edition-active {
                                z-index: 20;
                            }

                            .header {
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                padding: 14px 8px;
                                color: #ffffff;
                                background-color: #3a4149;
                                border-top-left-radius: 5px;
                                border-top-right-radius: 5px;

                                p {
                                    font-size: 14px;
                                    margin: 0;
                                }

                                i {
                                    cursor: pointer;
                                }
                            }

                            .edition {
                                .header {
                                    margin-bottom: 12px;
                                }

                                .edit-row {
                                    padding: 0 9px;

                                    label {
                                        display: block;
                                        margin: 8px 0;
                                        font-weight: 700;
                                    }
                                    input {
                                        display: block;
                                        width: 100%;
                                        padding: 8px 11px;
                                        -webkit-border-radius: 5px;
                                        -moz-border-radius: 5px;
                                        border-radius: 5px;
                                        border: 1px solid #cfd5d9;
                                        background-color: #f0f3f5;
                                        outline: none;
                                    }
                                }

                                .control-bar {
                                    display: flex;
                                    justify-content: flex-end;
                                    border-top: 0;
                                    margin-top: 20px;
                                    padding: 12px 9px;

                                    .btn {
                                        padding: 8px 20px;
                                    }
                                    .btn-success {
                                        margin-left: 10px;
                                    }
                                }
                            }

                            .pricing-row {
                                display: flex;
                                justify-content: space-between;
                                padding: 11px 9px;
                                &:nth-child(odd) {
                                    background-color: #f9f9f9;
                                }
                            }
                        }
                    }
                }

                .roaming-pricing {
                    padding: 20px;
                    border: 1px solid #C9CFD4;
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;

                    .roaming-pricing-list {
                        display: flex;
                        flex-wrap: wrap;

                        .roaming-pricing-box {
                            max-width: 250px;
                            width: 20%;
                            padding: 3px;
                            margin-right: 20px;
                            margin-bottom: 20px;
                            -webkit-border-radius: 5px;
                            -moz-border-radius: 5px;
                            border-radius: 5px;
                            border: 1px solid #dee1e3;
                            background-color: #fff;

                            &.mb-pricing {
                                &.hide-mb {
                                    display: none;
                                }
                            }

                            &.gb-pricing {
                                &.hide-gb {
                                    display: none;
                                }
                            }

                            &.edition-active {
                                z-index: 20;
                            }

                            .header {
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                padding: 14px 8px;
                                color: #ffffff;
                                background-color: #3a4149;
                                border-top-left-radius: 5px;
                                border-top-right-radius: 5px;

                                p {
                                    font-size: 14px;
                                    margin: 0;
                                }

                                i {
                                    cursor: pointer;
                                }
                            }

                            .edition {
                                .header{
                                    margin-bottom: 12px;
                                }

                                .edit-row {
                                    padding: 0 9px;

                                    label {
                                        display: block;
                                        margin: 8px 0;
                                        font-weight: 700;
                                    }
                                    input {
                                        display: block;
                                        width: 100%;
                                        padding: 8px 11px;
                                        -webkit-border-radius: 5px;
                                        -moz-border-radius: 5px;
                                        border-radius: 5px;
                                        border: 1px solid #cfd5d9;
                                        background-color: #f0f3f5;
                                        outline: none;
                                    }
                                }

                                .control-bar {
                                    display: flex;
                                    justify-content: flex-end;
                                    border-top: 0;
                                    margin-top: 20px;
                                    padding: 12px 9px;

                                    .btn {
                                        padding: 8px 20px;
                                    }
                                    .btn-success {
                                        margin-left: 10px;
                                    }
                                }
                            }

                            .pricing-row {
                                display: flex;
                                justify-content: space-between;
                                padding: 11px 9px;
                                &:nth-child(odd) {
                                    background-color: #f9f9f9;
                                }
                            }
                        }
                    }
                }
                .vodafone-pricing {
                    padding: 20px;
                    border: 1px solid #C9CFD4;
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;
                    .vodafone-pricing-list {
                        display: flex;
                        flex-wrap: wrap;

                        .vodafone-pricing-box {
                            max-width: 250px;
                            width: 20%;
                            padding: 3px;
                            margin-right: 20px;
                            margin-bottom: 20px;
                            -webkit-border-radius: 5px;
                            -moz-border-radius: 5px;
                            border-radius: 5px;
                            border: 1px solid #dee1e3;
                            background-color: #fff;

                            &.edition-active {
                                z-index: 20;
                            }

                            .header {
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                padding: 14px 8px;
                                color: #ffffff;
                                background-color: #3a4149;
                                border-top-left-radius: 5px;
                                border-top-right-radius: 5px;

                                p {
                                    font-size: 14px;
                                    margin: 0;
                                }

                                i {
                                    cursor: pointer;
                                }
                            }

                            .edition {
                                .header {
                                    margin-bottom: 12px;
                                }

                                .edit-row {
                                    padding: 0 9px;

                                    label {
                                        display: block;
                                        margin: 8px 0;
                                        font-weight: 700;
                                    }

                                    input {
                                        display: block;
                                        width: 100%;
                                        padding: 8px 11px;
                                        -webkit-border-radius: 5px;
                                        -moz-border-radius: 5px;
                                        border-radius: 5px;
                                        border: 1px solid #cfd5d9;
                                        background-color: #f0f3f5;
                                        outline: none;
                                    }
                                }

                                .control-bar {
                                    display: flex;
                                    justify-content: flex-end;
                                    border-top: 0;
                                    margin-top: 20px;
                                    padding: 12px 9px;

                                    .btn {
                                        padding: 8px 20px;
                                    }

                                    .btn-success {
                                        margin-left: 10px;
                                    }
                                }
                            }

                            .pricing-row {
                                display: flex;
                                justify-content: space-between;
                                padding: 11px 9px;

                                &:nth-child(odd) {
                                    background-color: #f9f9f9;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    #unsavedPrices___BV_modal_content_ {
        .modal-body {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 1rem;
            text-align: center;

            i {
                color: #0088FF;
                margin-bottom: 15px;
            }

            img {
                height: 19px;
                width: auto;
                margin-bottom: 15px;
            }

            h3 {
                display: block;
                margin-bottom: 18px;
                font-size: 15px;
                line-height: 18px;
                font-weight: 700;
                color: #2F353A;
            }

            h4 {
                display: block;
                margin-bottom: 20px;
                font-size: 14px;
                line-height: 24px;
                color: #515B65;
            }

            .button-wrapper {
                button {
                    margin: 0 5px;
                    padding-left: 15px;
                    padding-right: 15px;
                }
            }
        }
    }


    .dark-theme {
        .global-settings {
            .card-body {
                .bookmark-content {
                    .bookmarks {
                        .bookmark {
                            &.active {
                                border-color: #1a1c1d;
                                border-bottom: 1px solid #3a4149;
                            }
                        }
                    }
                    .domestic-pricing,
                    .roaming-pricing {
                        border-color: #1a1c1d;
                    }

                    .domestic-pricing {
                        .domestic-pricing-box {
                            border-color: #1d1f20;
                            background-color: #3a4149;
                            .header {
                                background-color: #2F353A;
                            }
                            .pricing-row {
                                &:nth-child(odd) {
                                    background-color: #383e45;
                                }
                            }

                            .edition {
                                .edit-row {
                                    input {
                                        background-color: #515b65;
                                        color: #ffffff;
                                        border-color: #1a1c1d;
                                    }
                                }
                            }
                        }
                    }

                    .roaming-pricing {
                        .roaming-pricing-box {
                            border-color: #1d1f20;
                            background-color: #3a4149;
                            .header {
                                background-color: #2F353A;
                            }
                            .pricing-row {
                                &:nth-child(odd) {
                                    background-color: #383e45;
                                }
                            }

                            .edition {
                                .edit-row {
                                    input {
                                        background-color: #515b65;
                                        color: #ffffff;
                                        border-color: #1a1c1d;
                                    }
                                }
                            }

                            //#383e45, #3a4149, #1d1f20
                        }
                    }

                    .vodafone-pricing {
                        border-color: #1d1f20;
                        .vodafone-pricing-box {
                            border-color: #1d1f20;
                            background-color: #3a4149;
                            .header {
                                background-color: #2F353A;
                            }
                            .pricing-row {
                                &:nth-child(odd) {
                                    background-color: #383e45;
                                }
                            }

                            .edition {
                                .edit-row {
                                    input {
                                        background-color: #515b65;
                                        color: #ffffff;
                                        border-color: #1a1c1d;
                                    }
                                }
                            }

                            //#383e45, #3a4149, #1d1f20
                        }
                    }
                }
            }
        }
    }

</style>
